// extracted by mini-css-extract-plugin
module.exports = {"details":"booking-details_details__2zhj5"};